import { useState, PropsWithChildren } from "react";
import styles from "./styles.module.scss";

export interface AnalysisAccordionProps {
  title?: string;
}

const AnalysisAccordion = ({ title, children }: PropsWithChildren<AnalysisAccordionProps>) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className={styles.wisaAnalysisAccordion}>
      <div className={styles.wisaAnalysisAccordionTitle} onClick={() => setIsActive(!isActive)}>
        {title && <p className={styles.wisaAnalysisAccordionTitleText}>{title}</p>}
        <div  className={styles.wisaAnalysisAccordionTitleCaret}>{isActive ? "-" : "+"}</div>
      </div>
      {isActive && children}
    </div>
  );
};

export default AnalysisAccordion;